import styled from 'styled-components';
import { TextButton } from '@oneaudi/unified-web-alpha-components';

export const ParallaxTeaser = styled.div`
  max-width: 1920px;
  margin: 0 auto;
`;

export const ParallaxArea = styled.div`
  position: relative;
  overflow: hidden;
  height: 1000px;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    height: 1400px;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.xl}px) {
    height: 1600px;
  }
`;

export const StyledLayout = styled.div`
  position: absolute;
  backface-visibility: hidden;
  width: 100%;
  left: 0;
  z-index: 1;
  will-change: transform;
  display: flex;
  justify-content: center;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    justify-content: flex-start;
  }
`;

export const StyledLayoutItem = styled.div`
  position: relative;
  box-sizing: border-box;
  background: ${({ theme }) => theme.colors.sysGradientElevationLevel1Fill};
  backdrop-filter: blur(60px);
  display: flex;
  flex-direction: column;
  gap: 24px;
  flex-shrink: 0;
  flex-basis: 86%;
  margin: var(--spacing-relative-3xl) auto 0 auto;
  padding: var(--spacing-relative-xl);
  border-radius: ${({ theme }) => theme.borderRadius.md}px;
  p h2 span {
    color: white;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    margin: var(--spacing-relative-3xl) 40px 0;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.lg}px) {
    margin: var(--spacing-relative-3xl) 60px 0;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.xl}px) {
    left: 4%;
    flex-basis: 44%;
    margin: var(--spacing-relative-3xl) 0 0;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.xxl}px) {
    margin: var(--spacing-relative-3xl) 0 0;
  }
`;

export const LegalArea = styled.div`
  background-color: ${({ theme }) => theme.colors.sysColorCanvas200};
  justify-content: center;
`;

export const LegalAreaItem = styled.div`
  padding-top: ${({ theme }) => theme.spacing.sysSpaceFixed200};
  padding-right: var(--page-margin);
  padding-bottom: var(--spacing-relative-xl);
  padding-left: var(--page-margin);
  flex-basis: 86%;
  shrink: 0;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    flex-basis: 92%;
  }
`;

export const WltpWrapper = styled.span`
  display: block;
`;

export const WltpSpan = styled.span``;

export const StyledTextButton = styled(TextButton)`
  > span {
    white-space: nowrap;
  }
`;

export const StyledImg = styled.img`
  position: absolute;
  left: 50%;
  will-change: transform;
  backface-visibility: hidden;
`;
